import { configureStore } from '@reduxjs/toolkit'
import fleet from './slices/fleetSlice'

export const store = configureStore({
  reducer: { fleet },
})
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
